import { render } from "./MachineLabsPage.vue?vue&type=template&id=1949747f"
import script from "./MachineLabsPage.vue?vue&type=script&lang=js"
export * from "./MachineLabsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__